/** Quand l’UI est encore en français (pas de settings:notificationTitles), mais le compte est NL. */
const NL_TITLES_WHEN_UI_HAS_NO_TRANSLATION: Record<string, string> = {
  cart_checkout_summary: 'Besteloverzicht (winkelwagen)',
  new_booking: 'Nieuwe boeking',
  forfait_purchased: 'Pakket verkocht',
  club_subscription_purchased: 'Nieuw clubabonnement',
  credit_pack_purchased: 'Verkoop van credits',
  booking_cancelled: 'Boeking geannuleerd',
  event_registration: 'Nieuwe inschrijving evenement',
  event_unsubscription: 'Uitschrijving evenement',
  payment_received: 'Betaling ontvangen',
  booking_confirmed: 'Boeking bevestigd',
  reschedule_request: 'Verzoek om te verzetten',
  new_message: 'Nieuw bericht',
  stay_booking_confirmed: 'Verblijf bevestigd',
  stay_booking_cancelled: 'Verblijf geannuleerd',
  new_stay_booking: 'Nieuwe opvangaanvraag',
  subscription_cancelled: 'Premium-abonnement beëindigd',
  boarding_subscription_cancelled: 'Opvangmodule uitgeschakeld',
  quote_accepted: 'Offerte geaccepteerd',
  quote_rejected: 'Offerte geweigerd',
};

export function quotesNamespaceLanguage(
  country?: string | null,
  invoiceLanguage?: string | null
): 'nl' | null {
  return accountUsesDutch(country, invoiceLanguage) ? 'nl' : null;
}

export function accountUsesDutch(
  country?: string | null,
  invoiceLanguage?: string | null
): boolean {
  const lang = String(invoiceLanguage || '')
    .trim()
    .replace(/_/g, '-')
    .toLowerCase();
  const code = String(country || '')
    .trim()
    .toUpperCase()
    .slice(0, 2);
  return lang.startsWith('nl') || (code === 'NL' && (lang === '' || lang === 'fr'));
}

/** Valeur select / affichage facturation : NL + vide/fr → nl. */
export function resolveInvoiceLanguageSelect(
  country?: string | null,
  invoiceLanguage?: string | null
): string {
  if (accountUsesDutch(country, invoiceLanguage)) return 'nl';
  const lang = String(invoiceLanguage || '')
    .trim()
    .replace(/_/g, '-')
    .toLowerCase();
  if (!lang) return 'fr';
  return lang.split('-')[0] || 'fr';
}

export function notificationRowTitle(
  type: string,
  apiTitle: string,
  translate: (key: string, options?: { defaultValue: string }) => string,
  country?: string | null,
  invoiceLanguage?: string | null
): string {
  const translated = translate(`settings:notificationTitles.${type}`, { defaultValue: '' });
  if (translated) return translated;
  if (accountUsesDutch(country, invoiceLanguage)) {
    return NL_TITLES_WHEN_UI_HAS_NO_TRANSLATION[type] || apiTitle;
  }
  return apiTitle;
}
